import React, { lazy } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";
import Fade from 'react-reveal/Fade';
import technologies_list from "../../data/Technologies_list";

const Technologies = () => {
 
const tech_list = technologies_list;
console.log(tech_list);
return  <>
            <Container fluid className="techcontainer">
                <Row>
                    <Fade bottom><center><h2 className="techheadName"><b>Technologies</b></h2></center></Fade>
                </Row>
                <Row>
                   {tech_list.map(function(t,i){
                       return (
                           <div className="techcard">
                           <Fade left>
                                <div className="techdiv" style={{color: "red"}}>
                                    <img src={t.img} alt="ourWork" className="techimg"/>
                                    <span>{t.name}</span>
                                </div>
                            </Fade> 
                           </div>
                       );
                   })}
                </Row>
            </Container>
        </>
}

export default Technologies;

